import {ProductBrand, ProductInterface} from "../../interfaces/product/ProductInterface";
import {Pride} from "./warranty/Pride";
import {Thorvik} from "./warranty/Thorvik";

export default function Warranty({product}:{product: ProductInterface}) {
    const renderWarrantyComponent = () => {
        switch (product.brand_name) {
            case ProductBrand.THORVIK:
                return <Thorvik />;
            default:
                return <Pride />;
        }
    };

    return (<div className="flex-column flex-lg-row gap-4  justify-content-between prod-pane">
        {renderWarrantyComponent()}
    </div>)
}